import { Radio } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-[#332f2b] bg-[#12100e]"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="w-9 h-9 rounded-full bg-[#FF6B00] flex items-center justify-center">
            <Radio size={18} className="text-[#12100e]" />
          </span>
          <div>
            <div className="font-anton uppercase text-lg tracking-wider text-[#F5F2EB]">
              Radio Rumore <span className="text-[#FF6B00]">Zero</span>
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#69635c]">
              60 · 70 · 80 · 90 — sempre in onda
            </div>
          </div>
        </div>
        <div className="font-mono text-[11px] uppercase tracking-widest text-[#69635c]">
          © {new Date().getFullYear()} Radio Rumore Zero · Tutti i diritti riservati
        </div>
      </div>
    </footer>
  );
}
